import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { UtilityService } from '../../core/services/utility.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { Sponsors } from '../../core/models/sponsors';
import { Observable } from 'rxjs/Observable';
import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { Category } from '../../core/models/category';
import { error } from 'util';
import { ExhibitorsService } from '../../core/services/exhibitors.service';
import { Exhibitor } from '../../core/models/exhibitor';
import { HideImage } from '../../core/models/hideImage';
import { Listing } from '../../core/models/listing';

@Component({
	selector: 'app-exhibitor-list',
	templateUrl: './exhibitor-list.component.html',
	styleUrls: ['./exhibitor-list.component.css'],
	providers: [ExtraService, UtilityService, ExhibitorsService]
})
export class ExhibitorListComponent implements OnInit {
	/* https://stackoverflow.com/a/44151580/2937847
		https://stackoverflow.com/a/42763164/2937847
	*/

	eventID: string;
	message: string;

	categoryItemNewText: string = null;
	categoryList: Array<Category> = new Array();
	categoryDeletedIdList: Array<string> = new Array();

	exhibitorId: string;
	exhibitorsList: Array<Exhibitor> = [];

	checkData: boolean = false;

	hasListOrderChanged: boolean = false;
	hasCategoryOrderChanged: boolean = false;

	listing = new Listing();
	hideImage = new HideImage();

	constructor(private extraService: ExtraService, private route: ActivatedRoute,
		private confirmationService: ConfirmationService, private multiUtilityService: MultiUtilityService,
		private exhibitorService: ExhibitorsService) {
		// super();
	}

	ngOnInit() {
		this.extraService.changeStateofSideBarButton(true);
		this.extraService.changeSideBar(true);
		this.route.params.subscribe(params => {
			if (params['eventId']) {
				this.eventID = params['eventId'];
				this.extraService.setCurrentEventId(params['eventId']);
				this.checkData = true;
				this.initCategoryList(params['eventId']);
				this.getExhibitorsList(params['eventId']);

				this.multiUtilityService.getPrefListing(params['eventId'], Constants.LIST_CATEGORY_EXHIBITOR).subscribe(pref => {
					this.listing.has_category_exhibitor = pref;
				});

				this.multiUtilityService.getPrefHiding(params['eventId'], Constants.HIDE_IMAGE_EXHIBITOR).subscribe(pref => {
					this.hideImage.hideImageExhibitor = pref;
				});
			}
		});
	}


	/*	CATEGORY RELATED FUNCTIONS	*/
	initCategoryList(eventId) {
		this.multiUtilityService.getCategoryList(eventId, Constants.CATEGORY_EXHIBITORS).subscribe(event => {
			if (event) {
				this.categoryList = new Array();
				for (let key in event) {
					let categoryItem = new Category();
					categoryItem.$key = key;
					categoryItem.position = event[key].position;
					categoryItem.text = event[key].text;
					this.categoryList[event[key].position] = categoryItem;
				}
				console.log('initCategoryList	:	' + this.categoryList.length);
			}
		});
	}

	onCategoryTextChange() {
		console.log("jnkjn");
		this.hasCategoryOrderChanged = true;
	}

	addCategoryItem() {
		if (this.categoryItemNewText != null && this.categoryItemNewText.trim().length > 0) {
			this.hasCategoryOrderChanged = true;

			let categoryItem = new Category();
			categoryItem.$key = null;
			categoryItem.position = this.categoryList.length;
			categoryItem.text = this.categoryItemNewText;
			this.categoryList.push(categoryItem);

			// Commented by Pranav
			for (var i = 0; i < this.categoryList.length; i++) {
				this.categoryList[i].position = i;
			}

			let key = this.multiUtilityService.addCategoryItem(this.eventID, this.categoryList, Constants.CATEGORY_EXHIBITORS);
			if (key) {
				this.message = 'Type Added Successfully';
				this.categoryItemNewText = null;
				setTimeout(() => {
					this.message = null;
					this.checkData = true;
				}, 1000);
			}
		}
	}

	upCategoryItem(index) {
		if (index != 0) {
			this.swapCategoryItem(index, index - 1);
		}
	}

	downCategoryItem(index) {
		if (index != this.categoryList.length - 1) {
			this.swapCategoryItem(index, index + 1);
		}
	}

	swapCategoryItem(index1, index2) {
		this.hasCategoryOrderChanged = true;

		let data = this.categoryList[index1];
		this.categoryList[index1] = this.categoryList[index2];
		this.categoryList[index2] = data;
	}

	confirmDeleteCategoryItem(item) {
		this.confirmationService.confirm({
			message: Constants.DELETE_MSG_SPONSOR + ' ' + item.text,
			accept: () => {
				this.deleteCategoryItem(item);
			}
		});
	}

	deleteCategoryItem(item) {
		this.hasCategoryOrderChanged = true;

		this.categoryDeletedIdList.push(item.$key);
		let index: number = this.categoryList.indexOf(item);
		if (index !== -1) {
			/* Remove category from List */
			this.categoryList.splice(index, 1);

			/* Reset position in categoryList */
			for (var i = 0; i < this.categoryList.length; i++) {
				this.categoryList[i].position = i;
			}
		}
	}

	/*	CATEGORY RELATED FUNCTIONS - END	*/

	/* Newly Added code */
	upListItem(index) {
		console.log("testtt");
		if (index != 0) {
			this.swapListItem(index, index - 1);
		}
	}

	downListItem(index) {
		if (index != this.exhibitorsList.length - 1) {
			this.swapListItem(index, index + 1);
		}
	}

	swapListItem(index1, index2) {
		this.hasListOrderChanged = true;

		let data = this.exhibitorsList[index1];
		this.exhibitorsList[index1] = this.exhibitorsList[index2];
		this.exhibitorsList[index2] = data;
	}

	getExhibitorsList(eventId: string) {
		let x = this.exhibitorService.getExhibitorsList(eventId);
		x.snapshotChanges().subscribe(list => {
			if (this.checkData) {
				this.exhibitorsList = [];
				list.forEach(element => {
					let y = element.payload.toJSON() as Exhibitor;
					y["$key"] = element.key;
					this.exhibitorsList[y.position] = (y as Exhibitor);
				});
				console.log(this.exhibitorsList);
				this.checkData = false;
			}
		});
	}

	confirmDeleteListItem(event: Exhibitor, value: string) {
		this.confirmationService.confirm({
			message: Constants.DELETE_MSG_EXH,
			accept: () => {
				this.deleteListItem(event);
			}
		});
	}

	deleteListItem(event: Exhibitor) {
		this.hasListOrderChanged = true;

		let index: number = this.exhibitorsList.indexOf(event);
		if (index !== -1) {
			this.exhibitorsList.splice(index, 1);
			for (var i = 0; i < this.exhibitorsList.length; i++) {
				this.exhibitorsList[i].position = i;
			}
		}

		this.exhibitorService.deleteExhibitor(event, this.eventID, this.exhibitorsList).then(res => {
			this.message = "Exhibitor deleted Successfully";
			setTimeout(() => {
				this.message = null;
				this.checkData = true;
				this.getExhibitorsList(this.eventID);
			}, 1000);
		}).catch(error => {
			console.log(error.message);
		});
	}


	submit() {
		console.log("		hasCategoryOrderChanged		" + this.hasCategoryOrderChanged + "hasListOrderChanged	" + this.hasListOrderChanged);
		if (this.hasListOrderChanged) {
			/* Reset position of List from 0 */
			for (var i = 0; i < this.exhibitorsList.length; i++) {
				this.exhibitorsList[i].position = i;
			}

			// TODO: Use a callback
			this.exhibitorService.updateExhibitorPosition(this.eventID, this.exhibitorsList);
			this.message = "Sponsors Updated";

			setTimeout(() => {
				this.message = null;
				this.checkData = true;
			}, 2000);
		}

		if (this.hasCategoryOrderChanged) {
			for (let i = 0; i < this.categoryList.length; i++) {
				this.categoryList[i].position = i;
			}
			let key = this.multiUtilityService.addCategoryItem(this.eventID, this.categoryList, Constants.CATEGORY_EXHIBITORS);
			if (this.categoryDeletedIdList.length > 0) {
				for (let item of this.categoryDeletedIdList) {
					this.multiUtilityService.deleteCategoryItem(this.eventID, item, Constants.CATEGORY_EXHIBITORS).then(res => {
						this.message = 'Type deleted Successfully';
						if (this.categoryDeletedIdList.indexOf(item) == this.categoryDeletedIdList.length) {
							this.initCategoryList(this.eventID);
						}
					});
				}
			} else {
				this.message = 'Type ordered Successfully';
			}
			setTimeout(() => {
				this.message = null;
				this.checkData = true;
			}, 2000);
		}

		this.multiUtilityService.updatePrefListing(this.eventID, Constants.LIST_CATEGORY_EXHIBITOR, this.listing.has_category_exhibitor);
		this.multiUtilityService.updatePrefHiding(this.eventID, Constants.HIDE_IMAGE_EXHIBITOR, this.hideImage.hideImageExhibitor);
	}
}



// WEBPACK FOOTER //
// /app/src/app/event/exhibitor-list/exhibitor-list.component.ts